import { SERVER_URL } from "../../api";
import axios from 'axios';
import { getHeaderWithToken } from "../../helpers/func";

export const VIEW_SUPPLY_REQUEST = 'VIEW_SUPPLY_REQUEST';
export const VIEW_SUPPLY_SUCCESS = 'VIEW_SUPPLY_SUCCESS';
export const VIEW_SUPPLY_ERROR = 'VIEW_SUPPLY_ERROR';
export const RESET_VIEW_SUPPLY = 'RESET_VIEW_SUPPLY';


export const viewSupply = (id) => {
    let headers = getHeaderWithToken();

    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: VIEW_SUPPLY_REQUEST
            })
            axios({
                method: 'GET',
                url: `${SERVER_URL}v1/supply/${id}`,
                headers: headers,
            }).then(function (response) {
                dispatch({
                    type: VIEW_SUPPLY_SUCCESS,
                    payload: response
                })
                resolve(response);
            })
                .catch(function (error) {
                    dispatch({
                        type: VIEW_SUPPLY_ERROR,
                        payload: error
                    })
                    reject(error)
                })
        })
    }
}

export const resetViewSupply = () => {
    return dispatch => {
        dispatch({
            type: RESET_VIEW_SUPPLY
        })
    }
}
